<div class="section-container flex flex-col items-center">
    <div class="text-section flex flex-col items-center justify-center gap-[16px]">
        <span class="title font-bold">Global Payments China Development Services - CDS</span>
        <span class="text font-normal">Collaboration Captured in One Moment Together</span>
    </div>
    <img class="image-desktop w-full" src="../../../assets/images/about-us/collaboration-image-container.png" alt="Collaboration Image" />
    <img class="image-tablet w-full" src="../../../assets/images/about-us/collaboration-image-container-tablet.png" alt="Collaboration Image" />
    <img class="image-mobile w-full" src="../../../assets/images/about-us/collaboration-image-container-mobile.png" alt="Collaboration Image" />
</div>
